import { connect } from 'react-redux';
import ResetPassword from './ResetPassword';
import {
  isFetching,
  isReset,
  getNewPassword,
  getNewPasswordError,
  getConfirmNewPassword,
  getConfirmNewPasswordError,
  getError,
  shouldShowNewPasswordError,
  shouldShowConfirmNewPasswordError,
  canFinishResetPassword,
} from '../../../state/reducers/ResetPasswordReducer';
import ResetPasswordActions from '../../../state/actions/ResetPasswordActions';

const mapStateToProps = (state) => ({
  isFetching: isFetching(state),
  confirmPassword: getConfirmNewPassword(state),
  confirmPasswordError: shouldShowConfirmNewPasswordError(state)
    ? getConfirmNewPasswordError(state)
    : '',
  password: getNewPassword(state),
  passwordError: shouldShowNewPasswordError(state)
    ? getNewPasswordError(state)
    : '',
  error: getError(state),
  canReset: canFinishResetPassword(state),
  isReset: isReset(state),
});

const {
  finishResetPasswordRequest,
  newPasswordChanged,
  confirmNewPasswordChanged,
  clearResetPassword,
} = ResetPasswordActions;

export default connect(mapStateToProps, {
  setNewPassword: finishResetPasswordRequest,
  passwordChanged: newPasswordChanged,
  confirmPasswordChanged: confirmNewPasswordChanged,
  resetState: clearResetPassword,
})(ResetPassword);



// WEBPACK FOOTER //
// ./src/view/forms/ResetPassword/index.js